/* eslint-disable no-unused-vars */
import { Message } from "element-ui";
import { getInfo, login, logout } from "../../api/auth";
import { getToken, removeToken, setToken, getUser, setUser } from "../../utils/auth";
import router, { resetRouter } from "../../router";
import userResource from "../../api/userResource";
import roleResource from "../../api/roleResource";
import { ActivityTypes } from "../../api/activityResource";

const defaulState = () => ({
  id: null,
  token: getToken(),
  username: "",
  firstName: "",
  lastName: "",
  avatar: "",
  roles: [],
  email: "",
  permissions: [],
});

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, defaulState());
  },
  SET_ID: (state, id) => {
    state.id = id;
  },
  SET_TOKEN: (state, { token, duration }) => {
    state.token = token;
    setToken(token, duration);
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
  },
  SET_USER: (state, user) => {
    // console.log("setting user", user);
    state.firstName = user.first_name;
    state.lastName = user.last_name;
    state.username = user.username;
    state.email = user.email;
    state.id = user.id;

    setUser(user);

    // state.firstName = user.first_name;
    // state.lastName = user.last_name;
    // state.username = user.username;
    // state.email = user.email;
    // state.id = user.id;
    // state.username = user.username;
  },
};

const actions = {
  // user login
  login({ commit, dispatch }, userInfo) {
    return new Promise((resolve, reject) => {
      // localStorage.setItem("userId", 2);
      // const basic = Buffer.from(userInfo.username + ":" + userInfo.password).toString("base64");
      // commit("SET_TOKEN", { token: basic, duration: userInfo.keepLoggedIn ? 30 : -1 });
      // resolve();

      login(userInfo)
        .then((response) => {
          // console.log("user info and response", userInfo, response);
          // const basic = Buffer.from(userInfo.username + ":" + userInfo.password).toString("base64");
          // commit("SET_TOKEN", { token: basic, duration: userInfo.keepLoggedIn ? 30 : -1 });

          console.log("login response: ", response);
          commit("SET_TOKEN", {
            token: response.token.access,
            duration: userInfo.keepLoggedIn ? 30 : -1,
          });
          commit("SET_ROLES", [response.data.group]);
          commit("SET_USER", response.data);
          console.log("user-login: ", response.data);
          localStorage.setItem("userId", response.data.id);

          // Log login activity
          dispatch(
            "activity/logActivity",
            {
              type: ActivityTypes.USER_LOGIN,
              details: { loginTime: new Date().toISOString() },
            },
            { root: true }
          );

          resolve(response);
        })
        .catch((error) => {
          console.log("login error: ", error);
          Message({
            message: "Login failed! Check credentials and try again.",
            type: "error",
            duration: 5000,
          });
          reject(error);
        });
    });
  },

  // get user info
  // TODO
  getInfo({ commit, state }) {
    let debug = true;
    if (debug) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          // const roles = ["admin"];
          // const permissions = ["view data"];
          // commit("SET_ROLES", roles);
          // commit("SET_PERMISSIONS", permissions);
          commit("SET_ROLES", [getUser().group]);
          commit("SET_USER", getUser());
          resolve({ roles: state.roles, permissions: [] });
        }, 0);
      });
    }
    /** Not Currently in Use */
    const toast = Message({ message: "Retrieving User Info...", type: "info", duration: 0 });
    const userId = localStorage.getItem("userId");
    return new Promise((resolve, reject) => {
      userResource
        .get(userId)
        .then((response) => {
          const { data } = response;
          // console.log("getinfo: ", data);
          if (!data) {
            toast.close();
            reject(new Error("Verification failed, please Login again."));
          }

          // role must be a non-empty array
          if (!data.role) {
            toast.close();
            reject(new Error("getInfo: role must be a non-null array!"));
          }

          let role;
          roleResource
            .get(data.role)
            .then((res) => {
              role = res.data;
              // console.log("role: ", role);
              commit("SET_ROLES", [role.name]);
              commit(
                "SET_PERMISSIONS",
                role.permissions.map((p) => p.name)
              );

              commit("SET_USER", { ...data.user });
              commit("SET_ID", data.id);

              toast.close();
              resolve({ roles: [role.name], permissions: role.permissions.map((p) => p.name) });
            })
            .catch((error) => {
              toast.close();
              reject(error);
            });
        })
        .catch((error) => {
          toast.close();
          reject(error);
        });
    });
  },

  // user logout
  // logout({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     console.log('@@');

  //     logout()
  //       .then(() => {
  //         removeToken();
  //         commit("RESET_STATE");
  //         resetRouter();
  //         resolve();
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // },

  logout({ commit, dispatch }) {
    return new Promise((resolve) => {
      console.log("@@");

      // Log logout activity before clearing state
      dispatch(
        "activity/logActivity",
        {
          type: ActivityTypes.USER_LOGOUT,
          details: { logoutTime: new Date().toISOString() },
        },
        { root: true }
      );

      // Remove token directly (no API call)
      removeToken();
      commit("RESET_STATE");
      resetRouter();

      resolve();
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      removeToken();
      resolve();
    });
  },

  // Dynamically modify permissions
  changeRoles({ commit, dispatch }, role) {
    return new Promise((resolve) => {
      const roles = [role.name];
      const permissions = role.permissions.map((permission) => permission.name);
      commit("SET_ROLES", roles);
      commit("SET_PERMISSIONS", permissions);
      resetRouter();

      // generate accessible routes map based on roles
      dispatch("permission/generateRoutes", { roles, permissions }).then((accessRoutes) => {
        router.addRoutes(accessRoutes);
        resolve();
      });
    });
  },
};

export default {
  namespaced: true,
  state: defaulState,
  mutations,
  actions,
};
